import React from 'react'
import logo from "../../assets/logo.png"
import { Link} from 'react-router-dom'

const Navbar = () => {
   
    const handleLogOut = () => {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        window.location.href = '/admin'
    }
    return (
      <nav className="bg-white py-2 md:py-4 sticky top-0 z-50">
        <div className="container px-4 mx-auto md:flex md:items-center">
          <div className="flex justify-between items-center">
            <Link to="/admin/dashboard" className="flex flex-row">
              <img
                loading="lazy"
                style={{ height: "60px" }}
                src={logo}
                alt="logo-home"
              />
              <h1 className="text-xl font-bold mt-5">
                Go <span className="text-green-600 ">Green Admin</span>
              </h1>
            </Link>
            <div id="mySidebar" className="sidebar bg-white hidden">
              <Link to="/admin/dashboard">Home</Link>
              <Link to="/admin/buyer-list">Buyers</Link>
              <Link to="/admin/seller-list">Sellers</Link>
              <Link to="/admin/product-list">Products</Link>
              <Link to="/admin/order-list">Orders</Link>
              <Link to="/admin/feedback-list">Feedbacks</Link>
            </div>
            <button
              onClick={() => {
                document.getElementById("mySidebar").style.width = "250px";
              }}
              className="border border-solid border-gray-600 px-3 py-1 rounded text-gray-600 opacity-50 hover:opacity-75 md:hidden"
              id="navbar-toggle"
            >
              <i className="fas fa-bars"></i>
            </button>
          </div>

          <div
            className="hidden md:flex flex-col md:flex-row md:ml-auto mt-3 md:mt-0 font-bold"
            id="navbar-collapse"
          >
            <Link
              to="/admin/dashboard"
              className="p-2 lg:px-4 md:mx-2 text-gray-600 rounded hover:bg-green-200 hover:text-gray-700 transition-colors duration-300"
            >
              Home
            </Link>
            <Link
              to="/admin/buyer-list"
              className="p-2 lg:px-4 md:mx-2 text-gray-600 rounded hover:bg-green-200 hover:text-gray-700 transition-colors duration-300"
            >
              Buyers
            </Link>
            <Link
              to="/admin/seller-list"
              className="p-2 lg:px-4 md:mx-2 text-gray-600 rounded hover:bg-green-200 hover:text-gray-700 transition-colors duration-300"
            >
              Sellers
            </Link>
            <Link
              to="/admin/product-list"
              className="p-2 lg:px-4 md:mx-2 text-gray-600 rounded hover:bg-green-200 hover:text-gray-700 transition-colors duration-300"
            >
              Products
            </Link>
            <Link
              to="/admin/order-list"
              className="p-2 lg:px-4 md:mx-2 text-gray-600 rounded hover:bg-green-200 hover:text-gray-700 transition-colors duration-300"
            >
              Orders
            </Link>
            <Link
              to="/admin/feedback-list"
              className="p-2 lg:px-4 md:mx-2 text-gray-600 rounded hover:bg-green-200 hover:text-gray-700 transition-colors duration-300"
            >
              Feedbacks
            </Link>
            <button
              onClick={handleLogOut}
              className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-full"
            >
              Log Out
            </button>
          </div>
        </div>
      </nav>
    );
}

export default Navbar